import {
  Card,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Row,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
} from 'reactstrap';
import moment from 'moment';
import { map, toString, toNumber, get } from 'lodash-es';
import { useHostChargingSessions } from 'utils/queries/hostQueries';
import { useState } from 'react';
import EarningModal from 'components/Modals/EarningModal.js';
import AmountTimeHostChart from 'components/chart/EarningHost.js';
import KwhTimeHostChart from 'components/chart/KwhHost';
import ReactPaginate from 'react-paginate';
import {
  seperateNumbersWithCommas,
  calculatePageOffset,
  humanizeDurationnHoursMinutes,
} from '../../utils/misc';
import { createUseStyles } from 'react-jss';
import classnames from 'classnames';
import AntTag from 'antd/lib/tag';
import 'antd/lib/tag/style/index.css';
import { CSVLink } from 'react-csv';

import {
  generateGranularityBasedDateRange,
  localDate,
  getTotalNumOfPages,
} from '../../utils/misc';

const useStyles = createUseStyles({
  transactionId: {
    color: '#438afe',
    '&:hover': {
      cursor: 'pointer',
    },
    fontWeight: 'bold',
  },
  pageNum: {
    fontWeight: 'bold',
    paddingRight: '10px',
    paddingLeft: '10px',
    paddingTop: '6px',
  },
  activePageNum: {
    backgroundColor: '#2675b8',
    color: 'white',
    borderRadius: '5px',
  },
  pagination: {
    display: 'flex',
    listStyle: 'none',
    paddingLeft: '0px',
    justifyContent: 'flex-end',
  },
});

const EarningList = () => {
  const classes = useStyles();

  const [hostSessionsPageNum, setHostSessionsPageNum] = useState(
    toNumber(localStorage.getItem('hostSessionsPageNum')) || 1,
  );
  const limit = 10;

  const {
    data: sessions,
    isLoading,
    error,
  } = useHostChargingSessions({
    limit,
    offset: calculatePageOffset(limit, hostSessionsPageNum),
    page: hostSessionsPageNum,
  });

  const [EarningModalOpen, setEarningModalOpen] = useState(false);
  const toggleEarningModal = () => setEarningModalOpen(!EarningModalOpen);
  const [selectedEarning, setSelectedEarning] = useState({});
  const [granularityRevenue, setGranularityRevenue] = useState('last_10_days');
  const [granularityTotalEnergySold, setGranularityTotalEnergySold] =
    useState('last_10_days');

  function generateHostSessionsCsvData(sessions) {
    const formattedSessions = map(sessions, (session) => {
      return {
        'TRANSACTION ID': get(session, 'TRANSACTIONID'),
        'CHARGER ID': get(session, 'CPID'),
        ADDRESS: get(session, 'ADDRESS'),
        'CONNECTOR ID': get(session, 'CONNECTORID'),
        'METER START': `${get(session, 'METER_START')} wH`,
        'METER STOP': `${get(session, 'METER_STOP')} wH`,
        'UNITS CONSUMED': `${toNumber(get(session, 'KWH_BILLED')).toFixed(
          2,
        )} kWh`,
        TARIFF: `₹ ${toNumber(get(session, 'BASE_KWH_COST')).toFixed(2)}`,
        'CHARGING STARTED AT': localDate(get(session, 'START_TIME')),
        'CHARGING ENDED AT': localDate(get(session, 'START_TIME')),
        DURATION:
          humanizeDurationnHoursMinutes(
            moment
              .duration(
                new Date(session.END_TIME) - new Date(session.START_TIME),
              )
              .asMinutes()
              .toFixed(2),
          ).string || 0,
        'AMOUNT ADDED IN WALLET': `₹ ${(
          toNumber(get(session, 'AMOUNT_ADDED')) / 100
        ).toFixed(2)}`,
        'AMOUNT REFUNDED': `₹ ${(
          toNumber(get(session, 'AMOUNT_REFUNDED')) / 100
        ).toFixed(2)}`,
        'AMOUNT CONSUMED EXCLUSIVE TAX': `₹ ${(
          toNumber(get(session, 'AMOUNT_CONSUMED')) / 100 -
          toNumber(get(session, 'AMOUNT_TAX')) / 100
        ).toFixed(2)}`,
        'TAX ON AMOUNT CONSUMED(18.0% GST)': `₹ ${(
          toNumber(get(session, 'AMOUNT_TAX')) / 100
        ).toFixed(2)}`,
        'NET TOTAL': `₹ ${toNumber(
          get(session, 'AMOUNT_CONSUMED') / 100,
        ).toFixed(2)}`,
      };
    });
    return formattedSessions;
  }

  const [activeTab, setActiveTab] = useState('1');
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  /* if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spinner style={{ color: '#2675b8' }} />
      </div>
    );
  } */

  if (error) {
    return <h1>Error</h1>;
  }

  return (
    <>
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <div>
              <Nav tabs>
                <NavItem style={{ cursor: 'pointer' }}>
                  <NavLink
                    className={classnames({
                      active: activeTab === '1',
                    })}
                    style={{
                      padding: '10px',
                      backgroundColor:
                        activeTab === '1' ? '#2675b8' : 'transparent',
                      color: activeTab === '1' ? 'white' : 'black',
                      border: activeTab === '1' ? 'none' : '1px solid #e4e8ec',
                      borderTopRightRadius: '0px',
                      paddingLeft: '20px',
                      paddingRight: '20px',
                    }}
                    onClick={() => {
                      toggle('1');
                    }}
                  >
                    Net Revenue
                  </NavLink>
                </NavItem>
                <NavItem style={{ cursor: 'pointer' }}>
                  <NavLink
                    className={classnames({
                      active: activeTab === '2',
                    })}
                    style={{
                      padding: '10px',
                      backgroundColor:
                        activeTab === '2' ? '#2675b8' : 'transparent',
                      color: activeTab === '2' ? 'white' : 'black',
                      border: activeTab === '2' ? 'none' : '1px solid #e4e8ec',
                      borderTopLeftRadius: '0px',
                      paddingLeft: '20px',
                      paddingRight: '20px',
                    }}
                    onClick={() => {
                      toggle('2');
                    }}
                  >
                    Energy Sold
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent
                activeTab={activeTab}
                style={{
                  padding: '10px',
                  backgroundColor: 'white',
                  borderRadius: '0px 0px 7px 7px',
                  boxShadow: '0 0 2rem 0 rgb(136 152 170 / 15%)',
                  height: '550px',
                }}
              >
                <TabPane tabId="1">
                  <Row>
                    <Col
                      sm="12"
                      md="12"
                      lg="12"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                      className="mt-3"
                    >
                      <div className="px-3 mt--1">
                        <h2 className="text mb-0">
                          Net Revenue{' '}
                          <span
                            style={{ fontSize: '12px', fontWeight: 'normal' }}
                          >
                            (Host)
                          </span>
                        </h2>
                        <p className="text mb-0" style={{ fontWeight: 500 }}>
                          {
                            generateGranularityBasedDateRange(
                              granularityRevenue,
                            ).startDate
                          }{' '}
                          -{' '}
                          {
                            generateGranularityBasedDateRange(
                              granularityRevenue,
                            ).endDate
                          }
                        </p>
                      </div>
                      <div className="px-3">
                        <Nav className="justify-content-end" pills>
                          <NavItem>
                            <NavLink
                              className={classnames('py-2 px-3', {
                                active: granularityRevenue === 'yearly',
                              })}
                              style={{
                                cursor: 'pointer',
                                border:
                                  granularityRevenue === 'yearly'
                                    ? '1px solid transparent'
                                    : '1px solid #2675b8',
                                color:
                                  granularityRevenue === 'yearly'
                                    ? 'white'
                                    : '#2675b8',
                                backgroundColor:
                                  granularityRevenue === 'yearly'
                                    ? '#2675b8'
                                    : 'white',
                              }}
                              preventDefault={true}
                              onClick={(e) => {
                                setGranularityRevenue('yearly');
                              }}
                            >
                              <span
                                className="d-none d-md-block"
                                style={{ cursor: 'pointer' }}
                              >
                                Year
                              </span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames('py-2 px-3', {
                                active: granularityRevenue === 'monthly',
                              })}
                              style={{
                                cursor: 'pointer',
                                border:
                                  granularityRevenue === 'monthly'
                                    ? '1px solid transparent'
                                    : '1px solid #2675b8',
                                color:
                                  granularityRevenue === 'monthly'
                                    ? 'white'
                                    : '#2675b8',
                                backgroundColor:
                                  granularityRevenue === 'monthly'
                                    ? '#2675b8'
                                    : 'white',
                              }}
                              preventDefault={true}
                              onClick={(e) => {
                                setGranularityRevenue('monthly');
                              }}
                            >
                              <span
                                className="d-none d-md-block"
                                style={{ cursor: 'pointer' }}
                              >
                                Monthly
                              </span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames('py-2 px-3', {
                                active: granularityRevenue === 'last_10_days',
                              })}
                              style={{
                                cursor: 'pointer',
                                border:
                                  granularityRevenue === 'last_10_days'
                                    ? '1px solid transparent'
                                    : '1px solid #2675b8',
                                color:
                                  granularityRevenue === 'last_10_days'
                                    ? 'white'
                                    : '#2675b8',
                                backgroundColor:
                                  granularityRevenue === 'last_10_days'
                                    ? '#2675b8'
                                    : 'white',
                              }}
                              data-toggle="tab"
                              preventDefault={true}
                              onClick={(e) => {
                                setGranularityRevenue('last_10_days');
                              }}
                            >
                              <span
                                className="d-none d-md-block"
                                style={{ cursor: 'pointer' }}
                              >
                                Last 10 days
                              </span>
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                    </Col>
                    <Col>
                      <div
                        className="chart mt-4 px-3"
                        style={{ paddingBottom: '20px' }}
                      >
                        <AmountTimeHostChart granularity={granularityRevenue} />
                      </div>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    <Col
                      sm="12"
                      md="12"
                      lg="12"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                      className="mt-3"
                    >
                      <div className="px-3 mt--1">
                        <h2 className="text mb-0">
                          Energy Sold{' '}
                          <span
                            style={{ fontSize: '12px', fontWeight: 'normal' }}
                          >
                            (Host)
                          </span>
                        </h2>
                        <p className="text mb-0" style={{ fontWeight: 500 }}>
                          {
                            generateGranularityBasedDateRange(
                              granularityTotalEnergySold,
                            ).startDate
                          }{' '}
                          -{' '}
                          {
                            generateGranularityBasedDateRange(
                              granularityTotalEnergySold,
                            ).endDate
                          }
                        </p>
                      </div>
                      <div className="px-3">
                        <Nav className="justify-content-end" pills>
                          <NavItem>
                            <NavLink
                              className={classnames('py-2 px-3', {
                                active: granularityTotalEnergySold === 'yearly',
                              })}
                              style={{
                                cursor: 'pointer',
                                border:
                                  granularityTotalEnergySold === 'yearly'
                                    ? '1px solid transparent'
                                    : '1px solid #2675b8',
                                color:
                                  granularityTotalEnergySold === 'yearly'
                                    ? 'white'
                                    : '#2675b8',
                                backgroundColor:
                                  granularityTotalEnergySold === 'yearly'
                                    ? '#2675b8'
                                    : 'white',
                              }}
                              preventDefault={true}
                              onClick={(e) => {
                                setGranularityTotalEnergySold('yearly');
                              }}
                            >
                              <span
                                className="d-none d-md-block"
                                style={{ cursor: 'pointer' }}
                              >
                                Year
                              </span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames('py-2 px-3', {
                                active:
                                  granularityTotalEnergySold === 'monthly',
                              })}
                              style={{
                                cursor: 'pointer',
                                border:
                                  granularityTotalEnergySold === 'monthly'
                                    ? '1px solid transparent'
                                    : '1px solid #2675b8',
                                color:
                                  granularityTotalEnergySold === 'monthly'
                                    ? 'white'
                                    : '#2675b8',
                                backgroundColor:
                                  granularityTotalEnergySold === 'monthly'
                                    ? '#2675b8'
                                    : 'white',
                              }}
                              preventDefault={true}
                              onClick={(e) => {
                                setGranularityTotalEnergySold('monthly');
                              }}
                            >
                              <span
                                className="d-none d-md-block"
                                style={{ cursor: 'pointer' }}
                              >
                                Monthly
                              </span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames('py-2 px-3', {
                                active:
                                  granularityTotalEnergySold === 'last_10_days',
                              })}
                              style={{
                                cursor: 'pointer',
                                border:
                                  granularityTotalEnergySold === 'last_10_days'
                                    ? '1px solid transparent'
                                    : '1px solid #2675b8',
                                color:
                                  granularityTotalEnergySold === 'last_10_days'
                                    ? 'white'
                                    : '#2675b8',
                                backgroundColor:
                                  granularityTotalEnergySold === 'last_10_days'
                                    ? '#2675b8'
                                    : 'white',
                              }}
                              data-toggle="tab"
                              preventDefault={true}
                              onClick={(e) => {
                                setGranularityTotalEnergySold('last_10_days');
                              }}
                            >
                              <span
                                className="d-none d-md-block"
                                style={{ cursor: 'pointer' }}
                              >
                                Last 10 days
                              </span>
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                    </Col>
                    <Col>
                      <div
                        className="chart mt-4 px-3"
                        style={{ paddingBottom: '20px' }}
                      >
                        <KwhTimeHostChart
                          granularity={granularityTotalEnergySold}
                        />
                      </div>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="mt-5" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow" style={{ minHeight: '400px' }}>
              <CardHeader
                className="border-0"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <h3 className="mb-0">
                  Charging Sessions{' '}
                  <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                    (Host)
                  </span>
                  {isLoading ? (
                    <Spinner
                      style={{
                        color: '#2675b8',
                        fontSize: '8px',
                        height: '20px',
                        width: '20px',
                        marginLeft: '15px',
                      }}
                    />
                  ) : null}
                </h3>

                <CSVLink
                  data={generateHostSessionsCsvData(sessions)}
                  filename={'Charging Sessions.csv'}
                  style={{
                    backgroundColor: '#2675b8',
                    color: 'white',
                    border: '0px solid transparent',
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    paddingLeft: '15px',
                    paddingRight: '15px',
                    borderRadius: '6px',
                    marginBottom: '0px',
                    height: '41px',
                    marginRight: '10px',
                    fontSize: '14px',
                    fontWeight: 600,
                  }}
                >
                  Export as CSV
                </CSVLink>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">KWH Billed</th>
                    <th scope="col">Date</th>
                    <th scope="col">Duration</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Meter Start</th>
                    <th scope="col">Meter Stop</th>
                    <th scope="col">Charger Id</th>
                  </tr>
                </thead>
                {isLoading ? null : (
                  <tbody>
                    {map(sessions, (session, s) => (
                      <tr key={s}>
                        <td
                          onClick={() => {
                            setSelectedEarning(session);
                            toggleEarningModal();
                          }}
                          className={classes.transactionId}
                        >
                          {toString(session.TRANSACTIONID)}
                          {session.LIMIT_TYPE === '0' ? (
                            <AntTag
                              color="volcano"
                              style={{
                                marginLeft: '8px',
                                fontWeight: 'normal',
                              }}
                            >
                              Admin Initiated
                            </AntTag>
                          ) : (
                            <AntTag
                              color="blue"
                              style={{
                                marginLeft: '8px',
                                fontWeight: 'normal',
                              }}
                            >
                              Customer Initiated
                            </AntTag>
                          )}
                        </td>

                        <td>{toNumber(session.KWH_BILLED).toFixed(2)} kWh</td>
                        <td>{localDate(session.START_TIME)}</td>
                        <td>
                          {humanizeDurationnHoursMinutes(
                            moment
                              .duration(
                                new Date(session.END_TIME) -
                                  new Date(session.START_TIME),
                              )
                              .asMinutes()
                              .toFixed(2),
                          ).string || 0}{' '}
                        </td>
                        <td>
                          ₹{' '}
                          {seperateNumbersWithCommas(
                            (toNumber(session.AMOUNT_BILLED) / 100).toFixed(2),
                          )}
                        </td>
                        <td>{session.METER_START} wH</td>
                        <td>{session.METER_STOP} wH</td>
                        <td>{session.CPID}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
              <CardFooter className="py-4">
                {sessions?.length > 0 ? (
                  <nav aria-label="...">
                    <ReactPaginate
                      previousLabel={
                        <div
                          style={{
                            border: '1px solid #e8ebee',
                            padding: '10px',
                            borderRadius: '50%',
                            width: '35px',
                            height: '35px',
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            marginRight: '10px',
                          }}
                          onClick={() => {
                            if (!hostSessionsPageNum === 1) {
                              setHostSessionsPageNum(hostSessionsPageNum - 1);
                            }
                          }}
                        >
                          <i
                            className="fas fa-angle-left"
                            style={{ color: '#94a3b3' }}
                          />
                        </div>
                      }
                      nextLabel={
                        <div
                          style={{
                            border: '1px solid #e8ebee',
                            padding: '10px',
                            borderRadius: '50%',
                            width: '35px',
                            height: '35px',
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            marginLeft: '10px',
                          }}
                          onClick={() => {
                            if (
                              !(
                                calculatePageOffset(
                                  limit,
                                  hostSessionsPageNum,
                                ) +
                                  limit >=
                                (toNumber(
                                  localStorage.getItem('pageTotalHostSessions'),
                                ) || 0)
                              )
                            ) {
                              setHostSessionsPageNum(hostSessionsPageNum + 1);
                            }
                          }}
                        >
                          <i
                            className="fas fa-angle-right"
                            style={{ color: '#94a3b3' }}
                          />
                        </div>
                      }
                      pageRangeDisplayed={2}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      initialPage={hostSessionsPageNum - 1}
                      pageCount={getTotalNumOfPages(
                        toNumber(localStorage.getItem('pageTotalHostSessions')),
                        limit,
                      )}
                      marginPagesDisplayed={2}
                      onPageChange={(data) => {
                        setHostSessionsPageNum(data.selected + 1);
                      }}
                      disableInitialCallback={true}
                      containerClassName={classes.pagination}
                      pageClassName={classes.pageNum}
                      activeClassName={classes.activePageNum}
                    />
                  </nav>
                ) : null}
              </CardFooter>
            </Card>
          </div>
        </Row>
        <EarningModal
          toggleModalOpen={toggleEarningModal}
          modalOpen={EarningModalOpen}
          selectedSession={selectedEarning}
        />
      </Container>
    </>
  );
};

export default EarningList;
